import { render } from "./UpdatePasswordSettingView.vue?vue&type=template&id=cbe45772"
import script from "./UpdatePasswordSettingView.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordSettingView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__